module.exports = __webpack_public_path__ + "img/fuzhujiagong.5c4fdbfa.jpg";